import update from 'immutability-helper';

import useCheckoutState from './useCheckoutState';
import { useEffect } from 'react';

export default function useCheckoutFormHelpers() {
  const { setForm, form, countryCode } = useCheckoutState();

  // set country code field after fetching
  useEffect(() => {
    // only continue if country code exists and is not initial country code (US)
    if (!countryCode) return;
    if (countryCode === 'US') return;

    const countryFields = Object.values(form.fields).filter(field => field.element === 'country');

    countryFields.forEach(field => {
      if (field.defaultValue?.enabled) {
        return;
      }

      setFormField(field._id, countryCode);
    });
  }, [countryCode]);

  function setVariantOption(variantId, optionId, quantity = 1) {
    setForm(form => {
      // Check if the variant with the selectedOption already exists
      const variantIndex = form.variants[variantId]?.findIndex(v => v.optionId === optionId);

      let newForm;

      const variantExists = variantIndex > -1;

      if (variantExists) {
        // Variant with selectedOption exists, update its quantity
        newForm = update(form, {
          variants: {
            [variantId]: {
              [variantIndex]: {
                quantity: {
                  $set: quantity,
                },
              },
            },
          },
        });
      } else {
        // Variant with selectedOption does not exist, add new entry
        newForm = update(form, {
          variants: {
            [variantId]: {
              $push: [{ optionId: optionId, quantity: quantity }],
            },
          },
        });
      }

      return newForm;
    });
  }

  function unsetVariantOption(variantId, optionId) {
    setForm(form => {
      // Check if the variant with the optionId already exists
      const variantIndex = form.variants[variantId]?.findIndex(v => v.optionId === optionId);

      let newForm;

      const variantExists = variantIndex > -1;

      if (variantExists) {
        // Variant with optionId exists, remove it
        newForm = update(form, {
          variants: {
            [variantId]: {
              $splice: [[variantIndex, 1]],
            },
          },
        });
      } else {
        // Variant with selectedOption does not exist, do nothing
        newForm = form;
      }

      return newForm;
    });
  }

  function setFormField(id, value, meta) {
    setForm(form =>
      update(form, {
        fields: {
          [id]: {
            value: {
              $set: value,
            },
            meta: {
              $set: meta,
            },
          },
        },
      }),
    );
  }

  function setFormStateByKey(key, value) {
    setForm(form => update(form, { [key]: { $set: value } }));
  }

  return {
    setVariantOption,
    unsetVariantOption,
    setFormField,
    setFormStateByKey,
  };
}
